var map = {
	"./en-US.js": [
		"ZxCx"
	],
	"./zh-CN.js": [
		"/j6Z",
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "FbuT";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang/locale lazy ^\.\/.*\.js$
// module id = FbuT
// module chunks = 16